import * as React from 'react';

import ExperimentalEoiForm from 'bundles/degree-description/components/modules/expression-of-interest/ExperimentalEoiForm';

// The parent (EoiButtonsBlock) spreads its full props onto this component so both can share one
// call site; only the fields actually used here are declared.
type Props = {
  trackingIndex?: number;
};

// This is the hero placement -- it hosts the EOI box directly, which owns its own card styling.
// Every other experimental EOI placement (header, mobile footer, inline module, at-a-glance block)
// scrolls the user here instead of rendering its own form.
const ExperimentalEoiButtonsBlock = ({ trackingIndex }: Props) => {
  return <ExperimentalEoiForm trackingIndex={trackingIndex} />;
};

export default React.memo(ExperimentalEoiButtonsBlock);
